export default () => (
  <svg width="291" height="297" viewBox="0 0 291 297" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="290" height="296" rx="15.5" fill="#212121" stroke="#313131" />
  </svg>

);
